import React from "react";
import { useIntl } from "react-intl";
import { isNull } from "lodash";
import { Box, Text, VStack, StackDivider } from "@chakra-ui/react";
import ItemRow from "./ItemRow";

import { modelPaymentSummary } from "./utils";

const SPACING = 3;

const PmInfo = ({ pt = 4, title, rows }) => {
  return (
    <Box pt={pt}>
      <Text fontSize="sm" fontWeight="semibold" pb={4}>
        {title}
      </Text>
      <VStack align="left" spacing={SPACING} divider={<StackDivider />}>
        {rows.map(({ title, value, currency }, i) => (
          <ItemRow key={i} title={title} value={value} currency={currency} />
        ))}
      </VStack>
    </Box>
  );
};

/**
 * PaymentSummary - Presentational component for displaying how a transaction was paid
 * @param {object} props
 * @param {TxnVariant} props.transaction
 * @returns JSX.Element
 */
export default function PaymentSummary({ transaction, accountId }) {
  const { formatMessage } = useIntl();

  const paymentSummary = modelPaymentSummary({transaction, accountId}, formatMessage);

  if (isNull(paymentSummary)) {
    return paymentSummary;
  }

  const { title, rows, secondaryData } = paymentSummary;

  return (
    <>
      <PmInfo title={title} rows={rows} />
      {secondaryData && <PmInfo title={secondaryData.title} rows={secondaryData.rows} />}
    </>
  );
}
